import React, { useEffect, useState } from "react";
import RemoteConsentForm from "../../components/RemoteConsentForm";
import { getUrlParams } from "../../utils/utils";
import useConsentFragment from "../../hooks/useConsentFragment";

const RemoteConsent = () => {
  const params = getUrlParams();
  const { getVersionInfo } = useConsentFragment();
  const [versionInfo, setVersionInfo] = useState();
  const getVersionDetails = async (obj) => {
    const { controller, scope, language } = obj;
    const data = await getVersionInfo(controller, scope, language);
    setVersionInfo(data);
  };
  useEffect(() => {
    const obj = {
      controller:
        params?.CountryCode?.toLowerCase() +
        "_" +
        params?.Division?.toLowerCase(),
      scope: "hcp",
      type: params?.SourceSystem?.toLowerCase(),
      value: params.CustomerID,
      language: params?.Language,
      bayer_id: params?.BayerID,
      external_provider_id: params?.externalProviderID,
    };
    getVersionDetails(obj);
  }, []);

  return <RemoteConsentForm values={params} versionInfo={versionInfo} />;
};

export default RemoteConsent;
